import { Box, DialogContent, Modal } from "@mui/material"
import {
  FocusContext,
  setFocus,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { usePageviewTracking } from "src/screens/Detail/use-pageview-tracking"
import { SettingsFocusKeys } from "src/screens/Settings/settings-focus-keys"

import { Footer } from "../../components/common/Footer"
import { useModalDismiss } from "../../hooks/use-modal-dismiss"
import { useTransitions } from "../../hooks/use-transitions"
import useTranslate, { Namespaces } from "../../hooks/use-translate"
import { appStore } from "../../store/AppStore"
import { comb, hwScroll, s } from "../../utilities/common"
import { theme } from "../../utilities/theme"

import { PTitle } from "./components/common"
import { SwitchBar } from "./components/SwitchBar"

export const StreamingModal = ({
  open,
  returnFocus,
}: {
  open: comb<boolean>
  returnFocus: string
}) => {
  if (!open.val) return null
  return <Screen open={open} returnFocus={returnFocus} />
}

const Screen = ({
  open,
  returnFocus,
}: {
  open: comb<boolean>
  returnFocus: string
}) => {
  const t = useTranslate()
  const t_common = useTranslate(Namespaces.Common)
  const scrollRef = useRef<HTMLElement>(null)

  const { ref, focusKey } = useFocusable({
    isFocusBoundary: true,
  })

  const track = usePageviewTracking()
  useEffect(() => {
    track("Settings", "settings/streaming")
  }, [])

  useModalDismiss(() => {
    setFocus(returnFocus)
    open.set(false)
  })

  useEffect(() => {
    setFocus(SettingsFocusKeys.StreamingDefault)
  }, [setFocus])

  const streaming = appStore((state) => state.streaming)
  /*const [switchLowData, setSwitchLowData] = useState(streaming.lowData)
  const handleSwitchLowData = (e: boolean) => {
    setSwitchLowData(e)
    setStreaming({ type: "lowData", value: e })
  }*/
  const [switchAtmos, setSwitchAtmos] = useState(streaming.atmos)
  const handleSwitchAtmos = (e: boolean) => {
    setSwitchAtmos(e)
    setStreaming({ type: "atmos", value: e })
  }

  const scrollFn = useCallback(
    (y: number) =>
      hwScroll({
        scrollRef,
        y,
      }),
    [scrollRef],
  )

  const setStreaming = appStore((state) => state.setStreaming)
  const canPlayAtmos = useMemo(() => window.capabilities.dolbyAtmos, [])
  const transition = useTransitions()

  return (
    <Modal
      open={open.val}
      sx={{
        height: "100vh",
        width: "100vw",
        backgroundColor: theme.palette.primary.variant,
        "& > *": { transition: "none !important" },
      }}
    >
      <DialogContent>
        <Box
          ref={scrollRef}
          style={{ transition }}
          sx={{
            height: "auto",
            minHeight: "100%",
            width: "100%",
            backgroundColor: theme.palette.primary.variant,
            position: "absolute",
            overflowY: "visible",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <FocusContext.Provider value={focusKey}>
              <Box
                ref={ref}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: s("1160px"),
                  mt: s("184px"),
                  "& > :not(:last-child)": {
                    mb: s("60px"),
                  },
                }}
              >
                <PTitle>{t("settings__streaming")}</PTitle>
                {/*<SwitchBar
                  focusParagraph={false}
                  focusKey={SettingsFocusKeys.StreamingDefault}
                  scrollFn={scrollFn}
                  onChange={handleSwitchLowData}
                  checked={switchLowData}
                  title={t_common("settings__low_data_mode")}
                  description={t_common(
                    "settings__streaming_loss_data_description"
                  )}
                />*/}
                <SwitchBar
                  focusKey={SettingsFocusKeys.StreamingDefault}
                  disabled={!canPlayAtmos}
                  focusParagraph={false}
                  scrollFn={scrollFn}
                  onChange={handleSwitchAtmos}
                  checked={canPlayAtmos && switchAtmos}
                  title={t_common("settings__streaming_dolby")}
                  description={
                    canPlayAtmos
                      ? t("settings__streaming_quality_subtitle")
                      : t("player__settings_audio_not_supported_device")
                  }
                />
              </Box>
            </FocusContext.Provider>
          </Box>
          <Footer />
        </Box>
      </DialogContent>
    </Modal>
  )
}
